import HeroSection from '../containers/HeroSection/HeroSection.tsx'
import LeadershipStorySection from '../containers/LeadershipStorySection/LeadershipStorySection.tsx'
import SkillsSection from '../containers/SkillsSection/SkillsSection.tsx'
import { PullQuote } from '../components/PullQuote/PullQuote.tsx'
import { WritingSection } from '../components/WritingSection/WritingSection.tsx'

const LandingPage = () => {
	return (
		<>
			<HeroSection />
			<SkillsSection />
			<PullQuote />
			<LeadershipStorySection />
			<WritingSection />
		</>
	)
}

export default LandingPage
